<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="new-reports d-flex flex-column pb-2">
      <div
        class="
          new-reports-header
          py-2
          px-3
          d-flex
          align-items-center
          justify-content-between
        "
      >
        <div class="title-nav d-flex align-items-center">
          <img
            src="../../assets/ReportsNew/goBack.svg"
            alt=""
            class="pointer"
            @click="goBack"
          />
          <span class="title">Panelist Reports</span>
        </div>
        <div class="daily-option">
          <button
            type="button"
            class="px-4 py-1 d-flex align-items-center"
            @click.stop="openDurationList"
          >
            <span>{{ DisplayTimeline }}</span>
            <img src="../../assets/ReportsNew/chevron_down.svg" alt="Open" />
          </button>
          <div
            class="report-duration-dropdown"
            style="margin-top: 2px"
            v-if="durationListOpen"
            ref="dropdown1"
          >
            <div
              class="duration-item pointer"
              :style="
                this.timeline == 'today' || this.storeTimeline == 'today'
                  ? 'background: #c8d9e5'
                  : ''
              "
              @click="setTimeline('today')"
            >
              Today
            </div>
            <div
              class="duration-item pointer"
              :style="
                this.timeline == 'thisWeek' || this.storeTimeline == 'thisWeek'
                  ? 'background: #c8d9e5'
                  : ''
              "
              @click="setTimeline('thisWeek')"
            >
              This Week
            </div>
            <div
              class="duration-item pointer"
              :style="
                this.timeline == 'thisMonth' ||
                this.storeTimeline == 'thisMonth'
                  ? 'background: #c8d9e5'
                  : ''
              "
              @click="setTimeline('thisMonth')"
            >
              This Month
            </div>
            <div
              class="duration-item pointer"
              :style="
                this.timeline == 'thisYear' || this.storeTimeline == 'thisYear'
                  ? 'background: #c8d9e5'
                  : ''
              "
              @click="setTimeline('thisYear')"
            >
              This Year
            </div>
            <div
              class="duration-item custom p-0"
              :style="
                this.timeline == 'custom' && this.appliedFilter
                  ? 'background: #c8d9e5'
                  : ''
              "
              @click="setTimeline('custom')"
            >
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-between
                  pointer
                "
                @click.stop="customDurationOpen = !customDurationOpen"
                style="padding: 8px 10px"
              >
                <span>Custom</span>
                <img
                  src="../../assets/ReportsNew/chevron_right.svg"
                  alt="Open Custom"
                  style="height: 8px"
                />
              </div>

              <div
                class="custom-duration-menu p-3"
                v-if="customDurationOpen"
                ref="dropdown2"
              >
                <span class="custom-title">Custom View</span>
                <div class="topDiv mt-3">
                  <DateField
                    :type="'date'"
                    :label="'From Date'"
                    :mandatory="false"
                    :placeholder="'Choose From Date'"
                    :id="'fromDate'"
                    :format="'DD-MM-YYYY'"
                    :vmodel="fromDate"
                    @select-value="fromDate = $event"
                  />
                </div>
                <div class="topDiv mt-3">
                  <DateField
                    :type="'date'"
                    :label="'To Date'"
                    :mandatory="false"
                    :placeholder="'Choose To Date'"
                    :id="'toDate'"
                    :format="'DD-MM-YYYY'"
                    :vmodel="toDate"
                    @select-value="toDate = $event"
                    :startDate="fromDate"
                  />
                </div>
                <div class="topDiv mt-3">
                  <DateField
                    :type="'time'"
                    :label="'Start Time'"
                    :mandatory="false"
                    :placeholder="'Choose Start Time'"
                    :id="'startPanTime'"
                    :format="'HH:mm:ss'"
                    :vmodel="startTime"
                    @select-value="startTime = $event"
                    :disabled="fromDate == '' && toDate == ''"
                    icon="time"
                  />
                </div>
                <div class="topDiv mt-3">
                  <DateField
                    :type="'time'"
                    :label="'End time'"
                    :mandatory="false"
                    :placeholder="'Choose End Time'"
                    :id="'endPanTime'"
                    :format="'HH:mm:ss'"
                    :vmodel="endTime"
                    @select-value="endTime = $event"
                    :disabled="fromDate == '' && toDate == ''"
                    icon="time"
                  />
                </div>

                <div class="d-flex justify-content-between mt-4 bluebtn">
                  <b-button class="acs-cancelBtn-filter" @click="cancelCustom"
                    >Cancel</b-button
                  >
                  <div class="d-flex">
                    <b-button
                      class="acs-cancelBtn-filter mr-3"
                      :disabled="fromDate == '' && toDate == ''"
                      @click="resetCustom"
                      >Reset</b-button
                    >
                    <b-button
                      class="acs-cancelBtn-filter"
                      :disabled="fromDate == '' && toDate == ''"
                      @click="applyCustom"
                      >Apply</b-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overview-tab px-3 py-3">
        <span class="tab-title">Overview</span>
        <div class="overview-items-flex d-flex align-items-center">
          <div class="overview-item">
            <span class="item-title">Total Panelists</span>
            <span class="item-value">{{ totalPanelist }}</span>
          </div>
          <div class="overview-item">
            <span class="item-title">Total Interviews Taken</span>
            <span class="item-value">{{ totalInterviews }}</span>
          </div>
          <div class="overview-item">
            <span class="item-title">Average Selection Confidence</span>
            <span class="item-value">10%</span>
          </div>
        </div>
      </div>

      <!-- Panelists Table -->
      <div class="table-panel px-1">
        <div
          class="
            table-title-bar
            d-flex
            align-items-center
            justify-content-between
            px-3
            py-2
          "
        >
          <span class="table-title">Panelist</span>
          <div class="search-export-options d-flex align-items-center">
            <div class="search-bar d-flex align-items-center px-3">
              <img
                src="../../assets/ReportsNew/searchIcon.svg"
                class="mt-1"
                alt=""
              />
              <b-form-input
                type="search"
                name="search"
                id="search"
                v-model.trim="panelSearchQuery"
                placeholder="Search Panelist"
                debounce="500"
                @update="getpanelSearch"
              />
            </div>
            <button
              type="button"
              class="export-excel px-4 py-1"
              @click="openExcel()"
            >
              Export Excel
            </button>
          </div>
        </div>
        <div class="table-container px-3 py-3">
          <div class="table-header px-3 py-2">
            <div
              class="header-item d-flex align-items-center"
              style="width: 30%"
            >
              <span>Panelist Name</span>
              <div class="sort-header p-1 d-flex flex-column">
                <img
                  v-if="panelSort != 'name'"
                  @click="sortData('name', 1)"
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="panelSort && panelOrder == 1"
                  @click="sortData('name', -1)"
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="panelSort && panelOrder == -1"
                  @click="sortData('name', 1)"
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div
              class="header-item d-flex align-items-center"
              style="width: 30%"
            >
              <span>Interviews Taken</span>
              <div class="sort-header p-1 d-flex flex-column">
                <img
                  v-if="panelSort != 'interviewCount'"
                  @click="sortData('interviewCount', 1)"
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="panelSort && panelOrder == 1"
                  @click="sortData('interviewCount', -1)"
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="panelSort && panelOrder == -1"
                  @click="sortData('interviewCount', 1)"
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div
              class="header-item d-flex align-items-center"
              style="width: 40%"
            >
              <span>Interviews Taken For</span>
            </div>
          </div>
          <div class="table-data-rows pr-1" @scroll="onScroll">
            <template
              v-if="
                (panelData.length == 0 &&
                  panelSearchQuery == '' &&
                  !showPanelLoader &&
                  !checkTimeLineData) ||
                panelMainLoader
              "
            >
              <div
                style="margin: auto"
                class="d-flex justify-content-center align-items-center h-100"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </template>
            <template
              v-else-if="
                panelData.length == 0 &&
                checkTimeLineData &&
                panelSearchQuery == ''
              "
            >
              <div
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  mt-2
                  h-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../assets/ReportsNew/no-reports-svg.svg"
                    alt=""
                  />
                </div>
                <div
                  class="no-matching-results-font mt-1 wordbreak text-center"
                >
                  No reports to show!
                </div>
              </div>
            </template>
            <template
              v-else-if="panelData.length == 0 && panelSearchQuery !== ''"
            >
              <div
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  mt-2
                  h-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../assets/ReportsNew/panel-wrong-search.svg"
                    alt=""
                  />
                </div>
                <div
                  class="no-matching-results-font mt-1 wordbreak text-center"
                >
                  No matching results found for "{{ panelSearchQuery }}"
                </div>
              </div>
            </template>
            <template v-else-if="panelData.length !== 0 && !panelMainLoader">
              <div
                class="data-row px-3 py-2 pointer"
                v-for="(pan, panIndex) in panelData"
                :key="panIndex"
                @click="SelectRow(pan.name, pan.panelID)"
                :class="selectedRow == pan.panelID ? 'data-row-selected' : ''"
              >
                <div class="data-item text-truncate" style="width: 30%">
                  <span
                    v-b-tooltip.hover.top="pan.name"
                    class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 80%"
                  >
                    {{ pan.name }}
                  </span>
                </div>
                <div class="data-item pl-1" style="width: 30%">
                  {{ pan.interviewCount }}
                </div>
                <div
                  class="data-item pl-1 d-flex align-items text-truncate"
                  style="width: 40%"
                >
                  <div
                    class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 100%"
                  >
                    <span :id="'panSkil' + pan.panelID">
                      {{ formattedSkills(pan.topSkills) }}
                    </span>
                    <span>
                      <b-tooltip
                        :target="'panSkil' + pan.panelID"
                        triggers="hover"
                        placement="top"
                      >
                        {{ allSkills(pan.topSkills) }}
                      </b-tooltip>
                    </span>
                  </div>
                </div>
              </div>
              <div
                style="margin: auto"
                v-if="showPanelLoader"
                class="d-flex justify-content-center mt-2"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- Overall Reports Section -->
      <div class="overall-reports relativeclass">
        <div
          class="
            overall-reports-header
            d-flex
            align-items-end
            justify-content-between
            w-100
          "
        >
          <div class="title-section d-flex flex-column" style="width: 75%">
            <span class="title">Overall Report</span>
            <span class="sub-title"
              >(Click on Panelist Name to see their report)</span
            >
          </div>
          <div style="position: absolute; right: 0">
            <div
              class="filter-section d-flex align-items-center"
              ref="filter"
              v-closable="{
                exclude: ['filter', 'filterdropdown'],
                handler: 'cancelFilterSection',
              }"
            >
              <div>Show Results for:</div>
              <div class="custom-dropdown">
                <div
                  class="selected-filter d-flex align-items-center w-100"
                  @click="toggleReportsFilter"
                >
                  <div class="text-truncate" style="width: 90px">
                    <div
                      class="d-inline-block text-truncate mt-1"
                      style="min-width: auto; max-width: 100%"
                    >
                      <template v-if="selectedRow == 'all'">
                        All Panelists
                      </template>
                      <template v-else>
                        {{ selectedRowName }}
                      </template>
                    </div>
                  </div>
                  <div>
                    <img
                      src="../../assets/ReportsNew/chev_down_blue.svg"
                      alt=""
                    />
                  </div>
                </div>

                <div
                  class="filter-list-dropdown"
                  v-if="overallReportsFilter"
                  style="width: 248px"
                >
                  <div class="filter-search">
                    <img src="../../assets/ReportsNew/searchIcon.svg" alt="" />
                    <b-form-input
                      type="search"
                      name="overallReportsSearch"
                      id="overallReportsSearch"
                      placeholder="Search"
                      v-model.trim="overAllSearchQuery"
                      debounce="500"
                      @update="searchoverALlPanel"
                    />
                  </div>
                  <div class="filter-list w-100" @scroll="scrollOverAllPanel">
                    <template
                      v-if="
                        (overAllPanelData.length == 0 &&
                          overAllSearchQuery == '' &&
                          !checkoverAllScrollLoader &&
                          !checkTimeLineData) ||
                        showOverAllLoader
                      "
                    >
                      <div
                        style="margin: auto"
                        class="
                          d-flex
                          justify-content-center
                          align-items-center
                          mt-2
                          h-100
                        "
                      >
                        <b-spinner label="Loading..."></b-spinner>
                      </div>
                    </template>
                    <template
                      v-if="
                        overAllPanelData.length == 0 &&
                        checkTimeLineData &&
                        !showOverAllLoader
                      "
                    >
                      <div
                        class="
                          no-matching-results-font
                          mt-1
                          wordbreak
                          text-center
                        "
                      >
                        No Records found
                      </div>
                    </template>
                    <template
                      v-else-if="
                        overAllPanelData.length !== 0 && !showOverAllLoader
                      "
                    >
                      <div
                        v-if="overAllSearchQuery == ''"
                        class="pointer"
                        @click="selectAllpanelRow"
                        :class="selectedRow == 'all' ? 'data-selected' : ''"
                      >
                        All Panelists
                      </div>
                      <div
                        class="w-100 wordbreak pointer"
                        v-for="(over, overIndex) in overAllPanelData"
                        :key="overIndex"
                        @click="SelectOverallRow(over.name, over.panelID)"
                        :class="
                          selectedRow == over.panelID ? 'data-selected' : ''
                        "
                      >
                        {{ over.name }}
                      </div>
                      <div
                        v-if="checkoverAllScrollLoader"
                        style="margin: auto"
                        class="
                          d-flex
                          justify-content-center
                          align-items-center
                          mt-2
                        "
                      >
                        <b-spinner label="Loading..."></b-spinner>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="overall-reports-flex">
          <div class="overall-reports-item px-1">
            <div class="report-title px-3 py-2">
              <span class="title">Interviews Taken</span>
            </div>

            <div
              style="margin: auto"
              v-if="heatmapSpinner"
              class="
                d-flex
                justify-content-center
                align-items-center
                h-100
                report-content
                p-2
              "
            >
              <b-spinner label="Loading..."></b-spinner>
            </div>

            <div v-else id="heatmap" class="report-content p-2"></div>
          </div>
        </div>
      </div>

      <!-- Candidates Feedback Provided Table -->
      <div class="table-panel px-1">
        <div
          class="
            table-title-bar
            d-flex
            align-items-center
            justify-content-between
            px-3
            py-2
          "
        >
          <span class="table-title">Candidate Feedback Provided</span>
          <div class="search-export-options d-flex align-items-center">
            <div class="search-bar d-flex align-items-center px-3">
              <img
                src="../../assets/ReportsNew/searchIcon.svg"
                class="mt-1"
                alt=""
              />
              <b-form-input
                type="search"
                name="search"
                id="search"
                placeholder="Search Candidate"
                v-model.trim="candidateSearchQuery"
                debounce="500"
                @update="getCandidateSearch"
              />
            </div>
            <div
              class="relativeclass"
              ref="mainFilterClosable"
              v-closable="{
                exclude: ['mainFilterClosable', 'mainFilterClosabledropdown'],
                handler: 'closemainFilterClosableFilter',
              }"
            >
              <button
                type="button"
                class="filter px-4 py-1 d-flex align-items-center"
                @click="toggleMainFilter"
              >
                <img src="../../assets/ReportsNew/filter_icon.svg" alt="" />
                Filter
              </button>
              <div class="filter-popup" v-if="mainFilter">
                <div class="mt-3">
                  <div class="acs-black-txt">Status:</div>
                  <div
                    @click="statusTypeToggle = !statusTypeToggle"
                    class="acs-filter-dropdown mt-2 position-relative pointer"
                  >
                    <span class="newManage-dropdown-place">
                      {{
                        statusType === "selected"
                          ? "Selected"
                          : statusType === "rejected"
                          ? "Rejected"
                          : statusType === "onhold"
                          ? "On Hold"
                          : "All"
                      }}
                    </span>
                    <img
                      src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
                      alt=""
                    />
                  </div>
                  <div v-if="statusTypeToggle" class="relativeclass">
                    <div class="newInt-radio-dropdown p-0">
                      <b-form-group class="sec-mcq-datacard">
                        <b-form-radio-group
                          class="newInt-radio-dropdown-inner-content w-100"
                          size="sm"
                          v-model="statusType"
                          :options="statusOptions"
                          @change="statusTypeToggle = false"
                          buttons
                          stacked
                        >
                        </b-form-radio-group>
                      </b-form-group>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-between mt-4 bluebtn">
                  <b-button class="acs-cancelBtn-filter" @click="cancelFilter"
                    >Cancel</b-button
                  >
                  <div class="d-flex">
                    <b-button
                      class="acs-cancelBtn-filter mr-3"
                      @click="resetFilter"
                      >Reset</b-button
                    >
                    <b-button class="acs-cancelBtn-filter" @click="applyFilter"
                      >Apply</b-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container px-3 py-3">
          <div class="table-header px-3 py-2">
            <div class="header-item d-flex align-items-center">
              <span>Candidate Name</span>
              <div class="sort-header p-1 d-flex flex-column">
                <img
                  v-if="candidateSort != 'interview.candidate.name'"
                  @click="sortCandidateData('interview.candidate.name', 1)"
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="candidateSort && candidateOrder == 1"
                  @click="sortCandidateData('interview.candidate.name', -1)"
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="candidateSort && candidateOrder == -1"
                  @click="sortCandidateData('interview.candidate.name', 1)"
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="header-item d-flex align-items-center">
              <span>Job Name</span>
              <div class="sort-header p-1 d-flex flex-column">
                <img
                  v-if="candidateSort != 'jobInfo.title'"
                  @click="sortCandidateData('jobInfo.title', 1)"
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="candidateSort && candidateOrder == 1"
                  @click="sortCandidateData('jobInfo.title', -1)"
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="candidateSort && candidateOrder == -1"
                  @click="sortCandidateData('jobInfo.title', 1)"
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="header-item d-flex align-items-center">
              <span>Rounds</span>
              <div class="sort-header p-1 d-flex flex-column">
                <img
                  v-if="candidateSort != 'interview.interviewRound.id'"
                  @click="sortCandidateData('interview.interviewRound.id', 1)"
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="candidateSort && candidateOrder == 1"
                  @click="sortCandidateData('interview.interviewRound.id', -1)"
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="candidateSort && candidateOrder == -1"
                  @click="sortCandidateData('interview.interviewRound.id', 1)"
                  class="pointer ml-2"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="header-item d-flex align-items-center">
              <span>Interview Date & Time</span>
            </div>
            <div class="header-item d-flex align-items-center">
              <span>Status</span>
            </div>
            <div class="header-item d-flex align-items-center">
              <span>Actions</span>
            </div>
          </div>
          <div class="table-data-rows pr-1" @scroll="onCandiadteScroll">
            <template
              v-if="
                (candidateData.length == 0 &&
                  candidateSearchQuery == '' &&
                  !showCandidateLoader &&
                  !checkTimeLineData) ||
                candidateMainLoader
              "
            >
              <div
                style="margin: auto"
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  mt-2
                  h-100
                "
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </template>
            <template
              v-else-if="
                candidateData.length == 0 &&
                checkTimeLineData &&
                candidateSearchQuery == ''
              "
            >
              <div
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  mt-2
                  h-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../assets/ReportsNew/no-reports-svg.svg"
                    alt=""
                  />
                </div>
                <div
                  class="no-matching-results-font mt-1 wordbreak text-center"
                >
                  No reports to show!
                </div>
              </div>
            </template>
            <template
              v-else-if="
                candidateData.length == 0 && candidateSearchQuery !== ''
              "
            >
              <div
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  mt-2
                  h-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../assets/ReportsNew/panel-wrong-search.svg"
                    alt=""
                  />
                </div>
                <div
                  class="no-matching-results-font mt-1 wordbreak text-center"
                >
                  No matching results found for "{{ candidateSearchQuery }}"
                </div>
              </div>
            </template>
            <template
              v-else-if="candidateData.length !== 0 && !candidateMainLoader"
            >
              <div
                class="data-row px-3 py-2"
                v-for="(cand, candIndex) in candidateData"
                :key="candIndex"
              >
                <span class="data-item text-truncate">
                  <span
                    v-b-tooltip.hover.top="cand.interview.candidate.name"
                    class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 80%"
                  >
                    {{ cand.interview.candidate.name }}
                  </span>
                </span>
                <span class="data-item text-truncate">
                  <span
                    v-b-tooltip.hover.top="cand.jobInfo.title"
                    class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 80%"
                  >
                    {{ cand.jobInfo.title }}
                  </span>
                </span>
                <span class="data-item">
                  <template v-if="cand.interview.interviewRound.id == 'F'">
                    F
                  </template>
                  <template v-else>
                    {{ cand.interview.interviewRound.roundOfrounds }}
                  </template>
                </span>
                <span class="data-item">
                  {{ formatDate(cand.interview.startTime) }}
                </span>
                <span class="data-item d-flex align-items-center">
                  <img
                    :src="getActionSrc(cand.recommendation)"
                    alt=""
                    class="px-1"
                  />
                  {{
                    cand.feedbackText
                      ? cand.feedbackText
                      : getActionText(cand.recommendation)
                  }}
                </span>
                <span class="data-item d-flex align-items-center">
                  <template>
                    <img
                      v-if="
                        cand.interview.candidate.candidateID !=
                        selectedCandidate.candidateID
                      "
                      v-b-tooltip.hover.top="'View Candidate'"
                      src="../../assets/talentpool/blueEye.svg"
                      alt=""
                      @click="viewCandidate(cand.interview.candidate)"
                      class="px-1 mr-2 pointer"
                    />

                    <img
                      v-else
                      src="../../assets/talentpool/notviewicon.svg"
                      alt=""
                      class="px-1 mr-2"
                    />
                  </template>
                  <img
                    v-b-tooltip.hover.top="'View Feedback'"
                    @click="openFeedbackForm(cand)"
                    src="../../assets/ReportsNew/view_feedback.svg"
                    alt=""
                    class="pointer"
                  />
                </span>
              </div>
              <div
                style="margin: auto"
                v-if="showCandidateLoader"
                class="d-flex justify-content-center mt-2"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- modal view particular candidates -->
      <PreviewCandidateSidebar
        v-if="viewCandidateModal"
        :showModal="viewCandidateModal"
        :candidateID="selectedCandidate.candidateID"
        :selectedCandidate="selectedCandidate"
        :customFieldsArray="customFieldsArray"
        :showNote="false"
        @close-view-icon="closeViewIcon"
      />

      <PreviewFeedbackStatic
        v-if="singleFeedbackModal"
        :basicCandInfo="singleBasicInfo"
        :ipmodal="singleFeedbackModal"
        :selectedRound="respVar"
        @closeModal="closeSingleFeedbackModal"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { heaTmap } from "vue-d3-charts-hire3x";
import {
  getPanelistInterviewReports,
  getPanelistCandidateReports,
  getCustomerFields,
  interviewReport,
  getPanelistInterviewReportsExcel,
} from "../../utils/apiFunctions.js";
import PreviewCandidateSidebar from "../../controllers/JD/modals/PreviewCandidateSidebar.vue";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import PreviewFeedbackStatic from "../../views/InterviewProcess/PreviewFeedbackStatic.vue";
import DateField from "../../components/InputComponents/DateField";

export default {
  name: "PanelistReports",
  data() {
    return {
      isExcelBoolean: false,
      listSize: 40,
      skillListOpen: false,
      durationListOpen: false,
      customDurationOpen: false,
      overallReportsFilter: false,
      timeline: "thisMonth",
      storeTimeline: "thisMonth",
      fromDate: "",
      toDate: "",
      startTime: "",
      endTime: "",
      appliedFilter: false,

      // interview table variables
      panelCount: 10,
      panelPage: 0,
      panelSort: "createdAt",
      panelOrder: -1,
      panelSearchQuery: "",
      panelData: [],
      showPanelLoader: false,
      panelPageEnd: null,
      panelTotal: null,
      panelMainLoader: false,
      totalInterviews: null,
      totalPanelist: null,
      selectedRow: "all",
      checkPanelScroll: false,

      // overall report
      overAllSearchQuery: "",
      showOverAllLoader: false,
      overAllPanelData: [],
      selectedRowName: "",
      selectedPanelID: "",
      heatmapSpinner: true,
      overAllSort: "createdAt",
      overAllCount: 10,
      overAllPage: 0,
      overAllOrder: -1,
      overAllTotal: null,
      overAllPageEnd: null,
      checkoverAllScrollLoader: false,

      // candidate table data variables
      candidateCount: 10,
      candidatePage: 0,
      candidateSort: "createdAt",
      candidateOrder: -1,
      candidateSearchQuery: "",
      candidateData: [],
      selectedCandidate: {},
      viewCandidateModal: false,
      customFieldsArray: [],
      candidateMainLoader: false,
      showCandidateLoader: false,
      candidatePageEnd: null,
      candidateTotal: null,
      LoaderStatus: false,
      singleFeedbackModal: false,
      singleBasicInfo: {},
      respVar: {},
      checkCandidateScroll: false,

      // storing data
      storeFromDate: "",
      storeToDate: "",
      storeStartTime: "",
      storeEndTime: "",

      // filter
      statusType: "all",
      statusOptions: [
        { text: "All", value: "all" },
        { text: "Selected", value: "selected" },
        { text: "Rejected", value: "rejected" },
        { text: "On Hold", value: "onhold" },
        { text: "No Show", value: "dna" },
      ],
      mainFilter: false,
      statusTypeToggle: false,
      appliedFilted: false,
      storeTypeSelected: "all",
    };
  },
  components: {
    Spinner,
    PreviewCandidateSidebar,
    PreviewFeedbackStatic,
    DateField,
  },
  created() {
    this.LoaderStatus = true;
    this.panelMainLoader = true;
    this.getPanelist();
    this.candidateMainLoader = true;
    this.getCandidateData();
    this.getCustomField();
    this.interViewHeatMap();
    if (this.$route.query.history) {
      this.viewCandidate(this.storedData.candidate);
    }
  },
  computed: {
    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
    }),
    ...mapGetters("jobDescriptionVUEX", {
      storedData: "getSelectedCandidate",
    }),
    DisplayTimeline() {
      if (this.timeline == "today" || this.storeTimeline == "today") {
        return "Today";
      } else if (
        this.timeline == "thisWeek" ||
        this.storeTimeline == "thisWeek"
      ) {
        return "This Week";
      } else if (
        this.timeline == "thisYear" ||
        this.storeTimeline == "thisYear"
      ) {
        return "This Year";
      } else if (this.timeline == "custom" && this.appliedFilter) {
        return "Custom";
      } else if (
        this.timeline == "thisMonth" ||
        this.storeTimeline == "thisMonth"
      ) {
        return "This Month";
      } else {
        return this.storeTimeline;
      }
    },
    checkTimeLineData() {
      return (
        this.timeline == "today" ||
        this.timeline == "thisWeek" ||
        this.timeline == "thisYear" ||
        this.timeline == "thisMonth" ||
        this.timeline == "custom"
      );
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    getActionSrc(rec) {
      let src;
      if (rec == "R") src = require("../../assets/ReportsNew/rejected.svg");
      else if (rec == "H") src = require("../../assets/ReportsNew/hold.svg");
      else if (rec == "NI" || rec == "DNA")
        src = require("../../assets/ReportsNew/no-show.svg");
      else src = require("../../assets/ReportsNew/selected.svg");
      return src;
    },
    getActionText(rec) {
      let text;
      if (rec == "R") text = "Rejected";
      else if (rec == "H") text = "On Hold";
      else if (rec == "NI") text = "Not Interested";
      else if (rec == "DNA") text = "No Show";
      else text = "Selected";
      return text;
    },
    convertDateFormat(dateStr) {
      if (dateStr) {
        const [day, month, year] = dateStr.split("-");
        return `${year}-${month}-${day}`;
      } else {
        return "";
      }
    },
    handleClickOutside(event) {
      let picker = document.getElementsByClassName("mx-datepicker-main")[0];
      let timeItem = event.target.closest("li.mx-time-item");
      let dropdown = this.$refs.dropdown1;
      if (
        !picker?.contains(event.target) &&
        !dropdown?.contains(event.target) &&
        !timeItem
      ) {
        this.fromDate = this.storeFromDate;
        this.toDate = this.storeToDate;
        this.startTime = this.storeStartTime;
        this.endTime = this.storeEndTime;
        this.durationListOpen = false;
        this.customDurationOpen = false;
        if (!this.appliedFilter) {
          this.appliedFilter = false;
        }
      }
    },
    openExcel() {
      this.isExcelBoolean = true;
      this.LoaderStatus = true;
      this.getExcel();
    },
    async getExcel() {
      try {
        let payload = {
          excel: this.isExcelBoolean,
          sortBy: this.panelSort,
          order: this.panelOrder,
          timeline: this.timeline,
          startDate: this.convertDateFormat(this.fromDate),
          endDate: this.convertDateFormat(this.toDate),
          startTime: this.startTime,
          endTime: this.endTime,
        };
        const res = await getPanelistInterviewReportsExcel(payload);
        if (res.status == 200) {
          this.LoaderStatus = false;
          // window.open(res.data.Detail.file);
          const href = URL.createObjectURL(res.data);

          // create "a" HTML element with href to file & click
          const link = document.createElement("a");
          link.href = href;
          link.setAttribute("download", `Panelist Reports.xlsx`);

          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        }
      } catch (err) {
        console.error(err);
      }
    },
    resetFilter() {
      this.storeTypeSelected = "all";
      this.statusType = "all";
      this.mainFilter = false;
      this.candidatePage = 0;
      this.candidateMainLoader = true;
      this.getCandidateData();
    },
    cancelFilter() {
      this.statusType = this.storeTypeSelected;
      this.mainFilter = false;
    },
    applyFilter() {
      this.appliedFilted = true;
      this.mainFilter = false;
      this.storeTypeSelected = this.statusType;
      this.candidatePage = 0;
      this.candidateMainLoader = true;
      this.getCandidateData();
    },
    toggleMainFilter() {
      this.mainFilter = !this.mainFilter;
      this.durationListOpen = false;
      this.customDurationOpen = false;
      this.overallReportsFilter = false;
    },
    closemainFilterClosableFilter() {
      this.mainFilter = false;
      this.statusTypeToggle = false;
      this.statusType = this.storeTypeSelected;
    },
    cancelFilterSection() {
      this.overallReportsFilter = false;
    },
    getpanelSearch() {
      this.panelPage = 0;
      this.panelMainLoader = true;
      this.getPanelist();
    },
    getCandidateSearch() {
      this.candidatePage = 0;
      this.getCandidateData();
    },
    cancelCustom() {
      this.fromDate = this.storeFromDate;
      this.toDate = this.storeToDate;
      this.startTime = this.storeStartTime;
      this.endTime = this.storeEndTime;
      this.durationListOpen = false;
      this.customDurationOpen = false;
      if (!this.appliedFilter) {
        this.appliedFilter = false;
      }
    },
    resetCustom() {
      this.storeFromDate = "";
      this.storeToDate = "";
      this.storeStartTime = "";
      this.storeEndTime = "";
      this.fromDate = "";
      this.toDate = "";
      this.startTime = "";
      this.endTime = "";
      this.appliedFilter = false;
      this.timeline = "thisMonth";
      this.storeTimeline = "thisMonth";
      this.panelMainLoader = true;
      this.getPanelist();
      this.candidateMainLoader = true;

      this.getCandidateData();
      this.showOverAllLoader = true;
      this.getOverAllPanelists();
      this.durationListOpen = false;
      this.customDurationOpen = false;
    },
    applyCustom() {
      this.appliedFilter = true;
      this.storeFromDate = this.fromDate;
      this.storeToDate = this.toDate;
      this.storeStartTime = this.startTime;
      this.storeEndTime = this.endTime;
      this.panelMainLoader = true;
      this.getPanelist();
      this.candidateMainLoader = true;
      this.getCandidateData();
      this.durationListOpen = false;
      this.customDurationOpen = false;
      this.storeTimeline = "custom";
      this.timeline = "custom";
      this.interViewHeatMap();
    },
    setTimeline(value) {
      this.timeline = value;
      if (this.selectedRow !== "all") {
        this.selectedRow = "all";
        this.selectedPanelID = "";
      }
      if (this.timeline !== "custom") {
        this.panelMainLoader = true;
        this.panelPage = 0;
        this.getPanelist();
        this.candidateMainLoader = true;
        this.getCandidateData();
        this.durationListOpen = false;
        this.customDurationOpen = false;
        this.storeTimeline = this.timeline;
        this.storeFromDate = "";
        this.storeToDate = "";
        this.storeStartTime = "";
        this.storeEndTime = "";
        this.interViewHeatMap();
      }
    },
    openFeedbackForm(cand) {
      this.singleFeedbackModal = true;
      this.respVar = cand.response.customFeedback;
      let getData = cand.response;
      this.singleBasicInfo["name"] = getData.name;
      const evalDate = getData.createdAt.split("T")[0];
      this.singleBasicInfo["evalDate"] = evalDate;
      this.singleBasicInfo["panel"] = getData.panelName;
      this.singleBasicInfo["modeOfInterview"] =
        cand.interview.interviewRound.type;
      this.singleBasicInfo["action"] = getData.recommendation;
      this.singleBasicInfo["remarks"] = getData.recruiterRemarks;
    },
    closeSingleFeedbackModal() {
      this.singleFeedbackModal = false;
    },
    onCandiadteScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(this.candidatePageEnd, 0, this.candidateTotal) &&
          !this.checkCandidateScroll
        ) {
          this.checkCandidateScroll = true;
          this.candidatePage++;
          this.getCandidateData();
        }
      }
    },
    async getCustomField() {
      try {
        let parentID = "5";
        let response = await getCustomerFields({ parentID });
        if (response.status == 200) {
          this.customFieldsArray = response.data.data.fields;
        }
      } catch (error) {
        console.error(error);
      }
    },
    viewCandidate(cand) {
      this.viewCandidateModal = true;
      this.selectedCandidate = cand;
    },
    closeViewIcon() {
      this.viewCandidateModal = false;
      this.selectedCandidate = {}; // Update selectedCandidate based on the event
    },
    sortCandidateData(sort, order) {
      this.candidateSort = sort;
      this.candidateOrder = order;
      this.candidatePage = 0;
      this.candidateMainLoader = true;
      this.getCandidateData();
    },
    formatDate(dateString) {
      const date = new Date(dateString);

      const timeFormatter = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });

      const dateFormatter = new Intl.DateTimeFormat("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
      });

      const time = timeFormatter.format(date);
      const formattedDate = dateFormatter.format(date);

      return `${time} ${formattedDate}`;
    },
    async getCandidateData() {
      try {
        let payload = {
          count: this.candidateCount,
          page: this.candidatePage,
          searchQuery: this.candidateSearchQuery,
          sortBy: this.candidateSort,
          order: this.candidateOrder,
          timeline: this.timeline,
          startDate: this.convertDateFormat(this.fromDate),
          endDate: this.convertDateFormat(this.toDate),
          startTime: this.startTime,
          endTime: this.endTime,
          filter: this.statusType,
        };
        if (this.selectedPanelID !== "") {
          payload.panelID = this.selectedPanelID;
        }
        const res = await getPanelistCandidateReports(payload);
        if (res.status == 200) {
          this.LoaderStatus = false;
          if (this.candidatePage == 0) {
            this.candidateData = res.data.data.data;
          } else {
            this.candidateData = [...this.candidateData, ...res.data.data.data];
          }
          this.candidateTotal = res.data.data.total;
          this.candidatePageEnd = res.data.data.pageEnd;

          if (res.data.data.total == res.data.data.pageEnd) {
            this.showCandidateLoader = false;
          } else {
            this.showCandidateLoader = true;
          }
          this.LoaderStatus = false;
          this.checkCandidateScroll = false;
          this.candidateMainLoader = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    SelectOverallRow(name, panelID) {
      this.selectedRow = panelID;
      this.selectedRowName = name;
      this.selectedPanelID = panelID;
      this.candidatePage = 0;
      this.candidateMainLoader = true;
      this.getCandidateData();
      this.overAllSearchQuery = "";
      this.overallReportsFilter = false;
      this.interViewHeatMap();
    },
    SelectRow(name, panelID) {
      if (this.selectedRow === panelID) {
        this.selectedRow = "all";
        this.selectedRowName = "";
        this.selectedPanelID = "";
      } else {
        this.selectedRow = panelID;
        this.selectedRowName = name;
        this.selectedPanelID = panelID;
      }

      this.candidatePage = 0;
      this.candidateMainLoader = true;
      this.getCandidateData();
      this.overAllSearchQuery = "";
      this.overallReportsFilter = false;
      this.interViewHeatMap();
    },
    selectAllpanelRow() {
      this.selectedRow = "all";
      this.selectedPanelID = "";
      this.candidatePage = 0;
      this.candidateMainLoader = true;
      this.getCandidateData();
      this.overAllSearchQuery = "";
      this.overallReportsFilter = false;
      this.interViewHeatMap();
    },
    searchoverALlPanel() {
      this.checkoverAllScrollLoader = true;
      this.overAllPanelData = [];
      this.overAllPage = 0;
      this.showOverAllLoader = true;
      this.getOverAllPanelists();
    },
    async getOverAllPanelists() {
      try {
        let payload = {
          page: this.overAllPage,
          order: this.overAllOrder,
          count: this.overAllCount,
          sortBy: this.overAllSort,
          searchQuery: this.overAllSearchQuery,
          timeline: this.timeline,
          startDate: this.convertDateFormat(this.fromDate),
          endDate: this.convertDateFormat(this.toDate),
          startTime: this.startTime,
          endTime: this.endTime,
        };
        const res = await getPanelistInterviewReports(payload);
        if (res.status == 200) {
          if (this.overAllCustPage == 0) {
            this.overAllPanelData = res.data.data.data;
          } else {
            this.overAllPanelData = [
              ...this.overAllPanelData,
              ...res.data.data.data,
            ];
          }
          this.overAllTotal = res.data.data.total;
          this.overAllPageEnd = res.data.data.pageEnd;
          this.checkoverAllScrollLoader = false;
          this.showOverAllLoader = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    scrollOverAllPanel(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(this.overAllPageEnd, 0, this.overAllTotal) &&
          !this.checkoverAllScrollLoader
        ) {
          this.checkoverAllScrollLoader = true;
          this.overAllPage++;
          this.getOverAllPanelists();
        }
      }
    },
    goBack() {
      this.$router.push({
        name: "ReportDashboard",
      });
    },
    onScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(this.panelPageEnd, 0, this.panelTotal) &&
          !this.checkPanelScroll
        ) {
          this.checkPanelScroll = true;
          this.panelPage++;
          this.getPanelist();
        }
      }
    },
    checkbetween(x, min, max) {
      return x > min && x < max;
    },
    sortData(sort, order) {
      this.panelSort = sort;
      this.panelOrder = order;
      this.panelPage = 0;
      this.panelMainLoader = true;
      this.getPanelist();
    },
    async getPanelist() {
      try {
        let payload = {
          count: this.panelCount,
          page: this.panelPage,
          searchQuery: this.panelSearchQuery,
          timeline: this.timeline,
          sortBy: this.panelSort,
          order: this.panelOrder,
          startDate: this.convertDateFormat(this.fromDate),
          endDate: this.convertDateFormat(this.toDate),
          startTime: this.startTime,
          endTime: this.endTime,
        };
        const res = await getPanelistInterviewReports(payload);
        if (res.status == 200) {
          if (this.panelPage == 0) {
            this.panelData = res.data.data.data;
          } else {
            this.panelData = [...this.panelData, ...res.data.data.data];
          }
          this.panelTotal = res.data.data.total;
          this.panelPageEnd = res.data.data.pageEnd;
          this.totalInterviews = res.data.data.totalInterviewsTaken;
          this.totalPanelist = res.data.data.totalPanelists;
          if (res.data.data.total == res.data.data.pageEnd) {
            this.showPanelLoader = false;
          } else {
            this.showPanelLoader = true;
          }
          this.LoaderStatus = false;
          this.checkPanelScroll = false;
          this.panelMainLoader = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    formattedSkills(skills) {
      if (!Array.isArray(skills) || skills.length === 0) {
        return "";
      }
      const skillNames = skills.map((skill) => skill.skillName);
      if (skillNames.length <= 3) {
        return skillNames.join(", ");
      } else {
        return skillNames.slice(0, 3).join(", ") + "...";
      }
    },
    allSkills(skills) {
      if (!Array.isArray(skills) || skills.length === 0) {
        return "";
      }
      return skills.map((skill) => skill.skillName).join(", ");
    },

    showAllSourcedSkills() {
      this.listSize = 100;
      this.skillListOpen = true;
    },
    openDurationList() {
      this.durationListOpen = !this.durationListOpen;
      this.customDurationOpen = false;
      this.overallReportsFilter = false;
    },
    toggleReportsFilter() {
      this.overallReportsFilter = !this.overallReportsFilter;
      this.overAllPage = 0;
      this.overAllPanelData = [];
      this.showOverAllLoader = true;
      this.getOverAllPanelists();
    },
    async interViewHeatMap() {
      if (
        document.getElementById("heatmap") &&
        document.getElementById("heatmap").innerHTML != ""
      ) {
        document.getElementById("heatmap").innerHTML = "";
      }
      this.heatmapSpinner = true;
      try {
        let payload;
        if (this.selectedPanelID != "" && this.selectedPanelID != null) {
          payload = {
            userID: this.roleValues.userID,
            panelID: this.selectedPanelID,
            // panelID: "L041223A001PA005",
            startDate: this.convertDateFormat(this.fromDate),
            endDate: this.convertDateFormat(this.toDate),
            startTime: this.startTime,
            endTime: this.endTime,
            timeline: this.timeline,
          };
        } else {
          payload = {
            userID: this.roleValues.userID,
            startDate: this.convertDateFormat(this.fromDate),
            endDate: this.convertDateFormat(this.toDate),
            startTime: this.startTime,
            endTime: this.endTime,
            timeline: this.timeline,
          };
        }
        let resp = await interviewReport(payload);
        if (resp.status == 200) {
          const myData = resp.data.data.interviewDatesAndDays;

          setTimeout(() => {
            if (document.getElementById("heatmap").innerHTML != "") {
              document.getElementById("heatmap").innerHTML = "";
            }
            let e = new heaTmap();
            e.heatMapGraph(myData);
            // e.heatmap2Temp(myData);
          }, 200);
        }
      } catch (error) {
        console.error(error);
      }
      this.heatmapSpinner = false;
    },
  },
};
</script>
<style scoped>
.new-reports {
  position: relative;
  padding: 15px 20px 20px 77px;
  top: 71px;
  height: calc(100vh - 71px);
  background-color: #e9ecef;
  overflow-y: scroll;
  font-family: "Lato", sans-serif;
}

.new-reports .new-reports-header {
  background-color: #f6f9fb;
  border-radius: 6px;
}

.new-reports .new-reports-header .title-nav {
  gap: 18px;
}

.new-reports .new-reports-header .title-nav .title {
  color: #20639b;
  font-weight: 600;
  font-size: 20px;
}

.new-reports .new-reports-header .daily-option {
  position: relative;
}

.new-reports .new-reports-header .daily-option .report-duration-dropdown {
  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 0 15px #82828290;
  z-index: 300;
}

.new-reports
  .new-reports-header
  .daily-option
  .report-duration-dropdown
  .duration-item {
  transition: all 0.2s ease;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 10px;
}

.new-reports
  .new-reports-header
  .daily-option
  .report-duration-dropdown
  .duration-item:hover {
  background-color: #e8eff4;
}

.new-reports
  .new-reports-header
  .daily-option
  .report-duration-dropdown
  .duration-item.custom {
  position: relative;
}

.custom-duration-menu {
  position: absolute;
  background: #ffffff;
  right: 100%;
  top: 0%;
  box-shadow: 0 0 15px #82828290;
  border-radius: 6px;
  width: 320px;
}

.custom-duration-menu .custom-title {
  font-weight: 600;
  font-size: 16px;
}

.custom-duration-menu form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.custom-button-field {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.custom-button-field button {
  padding: 4px 14px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 13px;
}

.custom-button-field button.cancel {
  color: #20639b;
  background-color: white;
  border: 2px solid #20639b;
}

.custom-button-field button.apply {
  color: white;
  background-color: #20639b;
  border: 2px solid #20639b;
}

.custom-duration-menu form .custom-input-field {
  display: flex;
  flex-direction: column;
}

.custom-duration-menu form .custom-input-field label {
  font-size: 14px;
}

.custom-duration-menu form .custom-input-field .date-picker-field {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 10px;
  justify-content: space-between;
  width: 100%;
  border: 1px solid #a8a8a8;
}

.custom-duration-menu form .custom-input-field .date-picker-field span {
  color: #667085;
}

.new-reports .new-reports-header .daily-option > button {
  gap: 18px;
  outline: none;
  border: none;
  background-color: #20639b;
  color: white;
  border-radius: 20px;
}

.new-reports .overview-tab {
  background: #fff;
  margin-top: 10px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.new-reports .overview-tab .tab-title {
  font-weight: 600;
}

.new-reports .overview-tab .overview-items-flex {
  gap: 32px;
  justify-content: space-evenly;
  flex-wrap: wrap;
  flex-grow: 1;
}

.new-reports .overview-tab .overview-items-flex .overview-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  font-weight: 500;
}

.new-reports .overview-tab .overview-items-flex .overview-item .item-value {
  color: #20639b;
}

.new-reports .table-panel {
  background-color: #fff;
  border-radius: 6px;
  margin-top: 10px;
}

.new-reports .table-panel .table-title-bar {
  border-bottom: 1px solid #dddddd;
}

.new-reports .table-panel .table-title-bar .table-title {
  font-weight: 600;
}

.new-reports .table-panel .table-title-bar .search-export-options {
  gap: 18px;
}

.new-reports .table-panel .table-title-bar .search-bar {
  /* gap: 12px; */
  background-color: #f4f4f6;
  width: max-content;
  border-radius: 20px;
}

.new-reports .table-panel .table-title-bar .search-bar input {
  background-color: transparent;
  border: none;
}

.new-reports .table-panel .table-title-bar .filter,
.new-reports .table-panel .table-title-bar .export-excel {
  outline: none;
  border: none;
  background-color: #20639b;
  color: white;
  border-radius: 20px;
  gap: 8px;
}

.new-reports .table-panel .table-container {
  position: relative;
}

.new-reports .table-panel .table-container .table-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.new-reports .table-panel .table-container .table-pagination > * {
  flex: 1;
}

.new-reports .table-panel .table-container .table-pagination .go-to {
  gap: 12px;
}

.new-reports .table-panel .table-container .table-pagination .go-to span {
  font-size: 14px;
  color: #20639b;
}

.new-reports .table-panel .table-container .table-pagination .go-to input {
  width: 30px;
  font-size: 14px;
  border: 1px solid rgb(181, 181, 181);
}

.new-reports .table-panel .table-container .table-pagination .go-to img {
  cursor: pointer;
}

.new-reports .table-panel .table-container .table-pagination .page-scrub {
  gap: 12px;
}

.new-reports
  .table-panel
  .table-container
  .table-pagination
  .page-scrub
  .page-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.new-reports .table-panel .table-container .table-pagination .page-scrub img {
  cursor: pointer;
}

.new-reports
  .table-panel
  .table-container
  .table-pagination
  .page-scrub
  .page-list
  .page-item {
  padding: 4px 8px;
  border-radius: 6px;
  color: #20639b;
  font-size: 14px;
  cursor: pointer;
}

.new-reports
  .table-panel
  .table-container
  .table-pagination
  .page-scrub
  .page-list
  .page-item.selected {
  background-color: #20639b;
  color: #fff;
}

.new-reports .table-panel .table-container .table-pagination .items-rows {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  font-size: 14px;
  color: #20639b;
}

.new-reports
  .table-panel
  .table-container
  .table-pagination
  .items-rows
  .rows-pp {
  gap: 10px;
}

.new-reports .table-panel .table-container .table-header {
  background-color: #e9f0f5;
  gap: 10px;
  display: flex;
  align-items: center;
}

.new-reports .table-panel .table-container .table-header .header-item {
  font-size: 14px;
  font-weight: 600;
  color: #20639b;
  gap: 4px;
}

.new-reports
  .table-panel
  .table-container
  .table-header
  .header-item
  .sort-header {
  gap: 2px;
}

.new-reports
  .table-panel
  .table-container
  .table-header
  .header-item
  .sort-header
  img {
  cursor: pointer;
}

.new-reports .table-panel .table-container .table-header > * {
  flex: 1;
}

.new-reports .table-panel .table-container .table-data-rows {
  margin-top: 10px;
  height: 300px;
  /* min-height: 365px; */
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.new-reports .table-panel .table-container .table-data-rows .data-row {
  background-color: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  border-left: 3px solid #20639b;
  box-shadow: 0 0 15px #dedede;
}

.new-reports .table-panel .table-container .table-data-rows .data-row-selected {
  background-color: #e3e3fe;
}

.data-selected {
  background-color: #e3e3fe;
}

.new-reports .table-panel .table-container .table-data-rows .data-row:hover {
  background-color: #e8eff4;
}

.new-reports .table-panel .table-container .table-data-rows .data-row > * {
  flex: 1;
  font-size: 15px;
  font-weight: 400;
  color: #20639b;
}

.new-reports .sourced-skills {
  margin-top: 10px;
  border-radius: 6px;
  background-color: #fff;
}

.new-reports .sourced-skills .source-title-bar {
  border-bottom: 1px solid #dddddd;
}

.new-reports .sourced-skills .source-title {
  font-weight: 600;
}

.new-reports .sourced-skills .skills-chips-flex {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.new-reports .sourced-skills .skills-chips-flex .chip {
  background-color: #eff6fb;
  color: #85a9c8;
  font-size: 14px;
  font-weight: 500;
}

.new-reports .sourced-skills .skills-chips-flex .chip.show-all {
  background-color: #85a9c8;
  color: #eff6fb;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}

/* Overall Reports Section */

.new-reports .overall-reports {
  margin-top: 10px;
}

.new-reports .overall-reports .overall-reports-header .title-section .title {
  font-weight: 600;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .title-section
  .sub-title {
  color: #888888;
  font-style: italic;
}

.new-reports .overall-reports .overall-reports-header .filter-section {
  gap: 10px;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown {
  position: relative;
  font-size: 14px;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .selected-filter {
  background-color: transparent;
  gap: 12px;
  color: #20639b;
  cursor: pointer;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown {
  position: absolute;
  right: 0;
  top: 30px;
  background-color: #fff;
  z-index: 300;
  border-radius: 6px;
  box-shadow: 0 0 15px #10101047;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown
  .filter-search {
  background-color: #f1f1f1;
  display: flex;
  align-items: center;
  padding: 2px 10px;
  gap: 10px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown
  .filter-search
  input {
  background-color: #f1f1f1;
  border: none;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown
  .filter-list {
  display: flex;
  flex-direction: column;
  min-height: auto;
  max-height: 165px;
  overflow-y: scroll;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown
  .filter-list
  > * {
  padding: 10px;
  cursor: pointer;
}

.new-reports .overall-reports .overall-reports-flex {
  display: flex;
  align-items: center;
  gap: 12px;
}

.new-reports .overall-reports .overall-reports-flex > * {
  flex: 1;
}

.new-reports .overall-reports .overall-reports-flex .overall-reports-item {
  background-color: #fff;
  border-radius: 6px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-title {
  border-bottom: 1px solid #dddddd;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content {
  position: relative;
  min-height: 250px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content
  .sample-legend {
  border-radius: 10px;
  border: 1px solid black;
  padding: 10px;
  width: max-content;
  position: absolute;
  bottom: 25px;
  right: 25px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content
  .sample-legend
  .legend-item {
  gap: 10px;
  font-size: 11px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content
  .sample-legend
  .legend-item
  .color-disc {
  height: 6px;
  aspect-ratio: 1/1;
  border-radius: 100%;
  background-color: green;
}

/* .tooltip {
  position: absolute;
  text-align: center;
  width: 100px;
  height: 50px;
  padding: 2px;
  font: 12px sans-serif;
  background: lightsteelblue;
  border: 0px;
  border-radius: 8px;
  pointer-events: none;
} */

/* Overall Reports Section End*/

@media screen and (max-width: 1024px) {
  .new-reports {
    padding: 15px 20px 0px 20px;
  }
}

.no-matching-results-font {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #344054;
}

.filter-popup {
  position: absolute;
  top: 100%;
  right: 0%;
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 0 15px #10101021;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 300;
  width: 270px;
}
</style>

<style>
.tooltipHeatmap {
  position: absolute;
  text-align: center;
  font-family: "Montserrat";
  font-size: 10px;
  font-weight: 400;
  line-height: 12.19px;
  color: #696969;
  pointer-events: none;
  width: auto;
  height: 30px;
  padding: 8.01px 12.01px;
  border-radius: 8px;
  background-color: #d9d9d9;
  opacity: 0;
}

.tooltipHeatmap::after {
  content: "";
  position: absolute;
  top: 100%; /* Position the arrow above the tooltip */
  left: 50%;
  transform: translateX(-50%) rotate(180deg);
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #d9d9d9 transparent; /* Arrow color matches the tooltip background */
}
</style>
